import { onCF7MailSent } from "./form-cf7-handlers";
/**
 * Custom Logic used in the Gifts in Wills DRTV Campaign page
 * @returns {[undefined]} []
 */

export function giwDrtvInit() {
  const form = $('#giw-drtv-form');

  if (!form.length) {
    return;
  }

  const cf7Form = form.closest('form');
  const requestType = form.find('#request-type');
  const magnetRow = form.find('#magnet-post-row');
  const magnetField = form.find('[name=magnet-post]');
  const addressRow = form.find('#address-validation');
  const submitButton = form.find('button[type=submit]');
  const successMessage = $('#giw-drtv-success');
  const emailRow = form.find('#email-row');
  const optionEmailRow = form.find('#option-email-row');

  const enquiryOptions = {
    email: 'Please email me the Gifts in Wills booklet',
    mail: 'Please mail me the Gifts in Wills booklet via post',
    confirm: 'I have already included a gift in my Will to Guide Dogs',
  };

  requestType.on('change', () => {
    if (requestType.val() === enquiryOptions.email) {
      magnetRow.show();
      addressRow.hide();
      emailRow.show();
      optionEmailRow.hide();
    } else if (requestType.val() === enquiryOptions.mail) {
      magnetRow.hide();
      addressRow.show();
      emailRow.hide();
      optionEmailRow.show();
    } else if (requestType.val() === enquiryOptions.confirm) {
      magnetRow.hide();
      addressRow.hide();
      emailRow.hide();
      optionEmailRow.show();
    } else {
      magnetRow.hide();
      addressRow.hide();
      emailRow.hide();
      optionEmailRow.hide();
    }
  });

  magnetField.on('change', () => {
    if (magnetField.is(':checked')) {
      addressRow.show();
    } else {
      addressRow.hide();
    }
  });

  // address service state handlers
  cf7Form.on('addressLoadingStart', () => {
    submitButton.attr('disabled', true);
    form.find('.ajax-loader').addClass('is-active');
  });

  cf7Form.on('addressLoadingStop', () => {
    submitButton.removeAttr('disabled');
    form.find('.ajax-loader').removeClass('is-active');
  });

  // show custom thank you message
  form.closest('.wpcf7').off('wpcf7mailsent', onCF7MailSent);
  form.closest('.wpcf7').on('wpcf7mailsent', () => {
    form.hide();
    form.find('.wpcf7-response-output').hide();
    successMessage.show();
    $('html, body').animate(
      {
        scrollTop: successMessage.offset().top - 200,
      },
      500,
    );
  });
}
